const getFirebaseConf = () => {
  let firebaseConfig: any = {
    apiKey: "AIzaSyAyIZBEmpfIpG7VzztGLdL_1XnphB72rYw",
    authDomain: "kfh-capital-crm-test.firebaseapp.com",
    projectId: "kfh-capital-crm-test",
    storageBucket: "kfh-capital-crm-test.appspot.com",
    messagingSenderId: "17095975918",
    appId: "1:17095975918:web:2479c809b213aad758a4ff",
    measurementId: "G-S5H54FBK7P"
  };

  // if (import.meta.env.VITE_ENV === 'production') {
    //yalhusayan@kfhcapital.com.kw production
    firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "",
      messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID || "",
      appId: import.meta.env.VITE_FIREBASE_APP_ID || "",
    };
  // }

  return firebaseConfig
}

export default getFirebaseConf;